import Image from "next/image";
import Link from "next/link";
import React, { FC } from "react";
import { Autoplay, Pagination } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";

type Props = {
  data: any;
};

const Education: FC<Props> = ({ data }) => {
  const pagination = {
    clickable: true,
    renderBullet: function (index: number, className: string) {
      return (
        '<div  class="' + className + " md:!inline-block !hidden " + '"></div>'
      );
    },
  };
  return (
    <div className="custom-bullet w-full">
      <Swiper
        spaceBetween={50}
        pagination={pagination}
        slidesPerView={1}
        modules={[Autoplay, Pagination]}
        autoHeight={true}
      >
        {data?.map((slide: any) => (
          <SwiperSlide key={JSON.stringify(slide?.image)}>
            <div className="relative  h-full cursor-pointer text-white">
              <Link
                href={slide?.link ?? ""}
                aria-label={slide?.title ?? " آموزش"}
              >
                <img
                  loading="lazy"
                  className="h-full w-full md:h-full"
                  src={slide?.image ?? "images/dadbanan-education.png"}
                  alt={slide?.title ?? " آموزش"}
                />
                {/*<Image*/}
                {/*  className="h-full w-full md:h-full"*/}
                {/*  src={slide?.image ?? "images/dadbanan-education.png"}*/}
                {/*  alt={slide?.title ?? " آموزش"}*/}
                {/*  width={200}*/}
                {/*  height={200}*/}
                {/*/>*/}
              </Link>
              {slide?.title && (
                <div
                  className="absolute top-1/2 left-1/2 flex h-auto w-11/12 -translate-x-1/2 -translate-y-1/2 flex-col justify-evenly rounded-md py-4 px-2 text-white md:right-[8%] md:w-7/12 md:translate-x-0 md:px-8 md:py-10 xl:w-5/12"
                  style={{
                    background:
                      slide?.color ??
                      "linear-gradient(270deg, rgba(54, 100, 148, 0.8) 0%, rgba(4, 128, 212, 0.8) 50%, rgba(39, 178, 188, 0.8) 100%)",
                  }}
                >
                  <div className="mb-3 text-sm md:text-xl">{slide?.title}</div>
                  <p className="text-xs md:text-lg"> {slide?.description}</p>
                </div>
              )}{" "}
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};
export default Education;
